import React from "react";
import { AlertTriangle } from "lucide-react";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

const DeleteRoleModal = ({ role, onCancel, onConfirm, isSubmitting }) => (
  <div className="rm-modal-overlay" onClick={onCancel}>
    <div className="rm-modal rm-modal-danger" onClick={(e) => e.stopPropagation()}>
      <div className="rm-modal-icon-danger">
        <AlertTriangle size={20} />
      </div>
      <h2 className="rm-modal-title">Delete “{role.name}”?</h2>
      <p className="rm-modal-subtitle">
        This will permanently remove this role and its permission configuration.
        This action cannot be undone.
      </p>
      <div className="rm-modal-actions rm-modal-actions-center">
        <SecondaryButton type="button" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="button" width="140px" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? "Deleting..." : "Delete Role"}
        </PrimaryButton>
      </div>
    </div>
  </div>
);

export default DeleteRoleModal;
